import {
  Checkbox,
  Loader,
  Segment,
  Table,
  Dimmer,
  Input,
  Button,
  Header,
} from "semantic-ui-react";
import moment from "moment";
const MailLog = (props) => {
  const {
    mailLogList,
    paginate,
    page,
    setFilter,
    filter,
    handleMailLog,
    loadingMail,
  } = props;

  const MailItems = () => {
    let list = [...mailLogList];
    const paged = paginate(list, 50, page);
    return paged.map((item, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{moment(item.createdAt).format("LLL")}</Table.Cell>
          <Table.Cell>{item.from}</Table.Cell>
          <Table.Cell>{item.to}</Table.Cell>
          <Table.Cell>{item.subject}</Table.Cell>
        </Table.Row>
      );
    });
  };
  return (
    <div>
      <Input
        fluid
        placeholder="Search by email..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        action={
          <Button
            icon="search"
            content="Search"
            onClick={() => handleMailLog()}
          />
        }
      />

      {loadingMail && (
        <Segment placeholder>
          <Dimmer active>
            <Loader size="large" content="Loading Mail Log..." />
          </Dimmer>
        </Segment>
      )}
      {!loadingMail && (
        <Table fixed sortable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted="descending">Sent</Table.HeaderCell>
              <Table.HeaderCell>From</Table.HeaderCell>
              <Table.HeaderCell>To</Table.HeaderCell>
              <Table.HeaderCell>Subject</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {mailLogList.length > 0 && (
            <Table.Body>
              <MailItems />
            </Table.Body>
          )}
        </Table>
      )}
      {mailLogList.length === 0 && !loadingMail && (
        <Segment
          placeholder
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Header
            content="Nothing to Display"
            subheader="Start by searching by email"
          />
        </Segment>
      )}
    </div>
  );
};
export default MailLog;
